import myAxios from "@/plugins/axios";

import {ANSWER_TYPES} from "@/constant/app";

const ADMIN_QUIZ = "/admin/quiz"

const quizService = {

    getQuizResults(params) {

        let queryParams = Object.keys(params).filter(key => key !== "campaignId" && params[key] !== null).map(key => key + '=' + params[key]).join('&');

        let resultsUrl = `${ADMIN_QUIZ}/result/${params.campaignId}`

        let apiUrl = queryParams ? `${resultsUrl}?${queryParams}` : resultsUrl

        return myAxios.privateInstance
            .get(apiUrl).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            });
    },

    exportLetters(ids, filename) {

        let apiUrl = `/result/letter/export?quizIds=${ids}`

        return myAxios.fileInstance
            .get(apiUrl).then(resp => {
                return resp
            }).then(resp => {

                // Let's create a link in the document that we'll
                // programmatically 'click'.
                const link = document.createElement('a');

                // Tell the browser to associate the response data to
                // the URL of the link we created above.
                link.href = window.URL.createObjectURL(
                    new Blob([resp.data])
                );

                // Tell the browser to download, not render, the file.
                link.setAttribute('download', filename);

                // Place the link in the DOM.
                document.body.appendChild(link);

                // Make the magic happen!
                link.click();

            })
            .catch(error => {
                throw new Error(error);
            });
    },

    filterQuizResults(params) {

        let apiUrl = `${ADMIN_QUIZ}/result/filter`

        return myAxios.privateInstance
            .post(apiUrl, params).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            });
    },

    loadProductScores(params) {

        return myAxios.privateInstance
            .get(`/product/scores/${params.campaignId}`).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    updateProductScores(params) {

        return myAxios.privateInstance
            .post(`/product/scores/${params.campaignId}`, params.productScores).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    getQuiz(campaignId) {

        return myAxios.privateInstance
            .get(`${ADMIN_QUIZ}/${campaignId}`).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    synchronizeResultsContacts(campaignId, results) {
        return myAxios.privateInstance
            .post(`${ADMIN_QUIZ}/result/campaign/${campaignId}/synch-contacts`, results).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            });
    },

    updateQuizProduct(params) {

        return myAxios.privateInstance
            .put(`/admin/quiz/product/update`, params).then(resp => {
                return resp
            })
            .catch(error => {
                throw new Error(error);
            });
    },

    isOneOptionQuestion: (question) => {
        return question && question.answerType === ANSWER_TYPES.ONE
    },
    isMultipleOptionsQuestion: (question) => {
        return question && question.answerType === ANSWER_TYPES.MULTIPLE
    },
    isTextQuestion: (question) => {
        return question && question.answerType === ANSWER_TYPES.TEXT
    },
    isRatingQuestion: (question) => {
        return question && question.answerType === ANSWER_TYPES.RATING
    },
    isFirstQuestion: (question) => {
        return question && question.order === 1
    },

}

export default quizService